<template>
  <b-card>

    <b-tabs content-class="mt-1">
      <!-- This tabs content will always be mounted -->
      <b-tab title="Whitelist">
        <validation-observer
          ref="whiteRule"
          tag="form"
          @submit.prevent
        >
          <b-col
            md="6"
          >
            <validation-provider
              v-slot="{ validate, errors }"
              name="whitelist"
              rules="required"
            >
              <b-form-group
                label="Upload MSISDN Whitelist"
                label-for="whitelist"
              >
                <b-form-file
                  id="whitelist"
                  ref="uploadWhiteMsisdn"
                  name="whitelist"
                  accept=".csv,.txt"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Please upload your .csv or .txt MSISDN in single row format"
                  @change="changeWhitelist($event) || validate($event)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-button
            variant="primary"
            @click.stop="validationWhiteChannel"
          >
            Import
          </b-button>
        </validation-observer>
      </b-tab>

      <!-- This tabs content will not be mounted until the tab is shown -->
      <!-- and will be un-mounted when hidden -->
      <b-tab
        title="Blacklist"
        lazy
      >
        <validation-observer
          ref="blackRule"
          tag="form"
          @submit.prevent
        >
          <b-col
            md="6"
          >
            <validation-provider
              v-slot="{ validate, errors }"
              name="blacklist"
              rules="required"
            >
              <b-form-group
                label="Upload MSISDN Blacklist"
                label-for="blacklist"
              >
                <b-form-file
                  id="blacklist"
                  ref="uploadBlackMsisdn"
                  name="blacklist"
                  required
                  accept=".csv,.txt"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Please upload your .csv or .txt MSISDN in single row format"
                  @change="changeBlacklist($event) || validate($event)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-button
            variant="primary"
            @click.stop="validationBlackChannel"
          >
            Import
          </b-button>
        </validation-observer>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  //   BAlert,
  BCol,
  BFormFile,
  BFormGroup,
  //   BFormInput,
  //   BFormRadio,
  //   BFormCheckboxGroup,
  BButton,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import {
  ValidationProvider,
  ValidationObserver,
  extend,
} from 'vee-validate'
import {
  required,
} from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: 'This field is required!',
})

export default {
  components: {
    BTabs,
    BTab,
    BCard,
    // BAlert,
    BCol,
    BFormGroup,
    BFormFile,
    // BFormInput,
    // BFormRadio,
    // BFormCheckboxGroup,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      setting: {
        whitelist: '',
        blacklist: '',
      },
    }
  },
  computed: {
    ...mapGetters('tools', {
      getWhiteList: 'getWhiteList',
      getBlackList: 'getBlackList',
    }),
  },
  methods: {
    ...mapActions('tools', {
      uploadWhite: 'uploadWhitelist',
      uploadBlack: 'uploadBlacklist',
    }),
    changeWhitelist(e) {
      const file = e.target.files[0]
      if (file.type === 'application/vnd.ms-excel' || file.type === 'text/plain') {
        this.setting.whitelist = file
      } else {
        this.$refs.whiteRule.setErrors('File type not support')
        // console.log('error')
      }
    },
    changeBlacklist(e) {
      const file = e.target.files[0]
      if (file.type === 'application/vnd.ms-excel' || file.type === 'text/plain') {
        this.setting.blacklist = file
      } else {
        this.$refs.whiteRule.setErrors('File type not support')
        // console.log('error')
      }
      // console.log(this.setting.blacklist)
    },
    uploadWhitelist() {
      // console.log(this.setting.whitelist)
      const formData = new FormData()
      formData.append('upload_whitelist', this.setting.whitelist)
      // eslint-disable-next-line no-unused-vars
      this.uploadWhite(formData).then(result => {
        // console.log(result, 'whitelist')
        this.$swal({
          icon: 'success',
          title: 'Whitelist MSISDN successfully uploaded!',
          // text: 'Thank you for your payment. Your credit is now topped up.',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          allowOutsideClick: false,
        })
        this.$refs.uploadWhiteMsisdn.reset()
      })
    },
    uploadBlacklist() {
      // console.log(this.setting.blacklist)
      const formData = new FormData()
      formData.append('upload_blacklist', this.setting.blacklist)
      // eslint-disable-next-line no-unused-vars
      this.uploadBlack(formData).then(result => {
        // console.log(result, 'blacklist')
        this.$swal({
          icon: 'success',
          title: 'Blacklist MSISDN successfully uploaded!',
          // text: 'Thank you for your payment. Your credit is now topped up.',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          allowOutsideClick: false,
        })
        this.$refs.uploadWhiteMsisdn.reset()
      })
    },
    validationWhiteChannel() {
      // return true
      return new Promise((resolve, reject) => {
        this.$refs.whiteRule.validate().then(success => {
          if (success) {
            this.uploadWhitelist()
            resolve(true)
            this.$refs.whiteRule.refs.whitelist.value = null
            this.$refs.whiteRule.reset()
          } else {
            reject()
          }
        })
      })
    },
    validationBlackChannel() {
      // return true
      return new Promise((resolve, reject) => {
        this.$refs.blackRule.validate().then(success => {
          if (success) {
            this.uploadBlacklist()
            resolve(true)
            this.$refs.blackRule.refs.whitelist.value = null
            this.$refs.blackRule.reset()
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>
